import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=defe5e96&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defe5e96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('defe5e96')) {
      api.createRecord('defe5e96', component.options)
    } else {
      api.reload('defe5e96', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=defe5e96&scoped=true&", function () {
      api.rerender('defe5e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LMIX710iBt7z/JS/comp/SearchFilterTokens.vue"
export default component.exports